import { _t } from '@bark/bark-core';
export default function () {
	const { QS } = window;

	const hasLoadingMsg = () => QS.hasKey('loading-msg');

	const getLoadingMsg = () => {
		switch (QS.getValue('loading-msg', null)) {
			case 'loading-professionals':
				return _t('buyer_seller-list:loading.loading-more-professionals');
			case 'requesting-replies':
				return _t('buyer_seller-list:loading.requesting-replies');
			default:
				return null;
		}
	};

	const clearLoadingMsg = () => QS.deleteValue('loading-msg');

	return {
		hasLoadingMsg,
		getLoadingMsg,
		clearLoadingMsg,
	};
}
